import UiFormWithStringId from "./UiFormWithStringId";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormCodePropertyBaseInfo extends UiFormWithStringId {
    constructor() {
        //无参构造函数
        super()
        this.IsLeaf = false;
        this.IsEnum = false;
        this.IsList = false;
        this.Properties = [];
    }

    [proName: string]: any;
    /**
     * 注释
     */
    Summary?: string;
    /**
     * 名称
     */
    Name?: string;
    /**
     * 类型
     */
    Type?: string;
    /**
     * 叶子
     */
    IsLeaf?: boolean;
    /**
     * 枚举
     */
    IsEnum?: boolean;
    /**
     * 集合
     */
    IsList?: boolean;
    /**
     * 属性
     */
    Properties?: DtoFormCodePropertyBaseInfo[];
}

/**
 * -表单校验
 */
export const DtoFormCodePropertyBaseInfoRules = {
    Summary: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
    ],
    Name: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
    ],
    Type: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
    ],
}

/**
 * -设置项
 */
export const DtoFormCodePropertyBaseInfoMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Summary",
    Label: "注释",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "Name",
    Label: "名称",
    Customize: true,
  },
  {
    Prop: "Type",
    Label: "类型",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "IsLeaf",
    Label: "叶子",
    Type: EnumMiezzFormItemType.Switch,
  },
  {
    Prop: "IsEnum",
    Label: "枚举",
    Type: EnumMiezzFormItemType.Switch,
  },
  {
    Prop: "IsList",
    Label: "集合",
    Type: EnumMiezzFormItemType.Switch,
  },
  {
    Prop: "Properties",
    Label: "属性",
    Type: EnumMiezzFormItemType.InputText,
  },
]
